import {
  LOCAL_AUTH_STORAGE_KEYS,
  LoginType,
} from '../constants'
import { clearStoredAccessToken } from './storage'

const decodeCallbackState = (state: string | null) => {
  if (!state) return ''

  try {
    return atob(state)
  } catch (e) {
    return state
  }
}

const getLoginTypeFromState = (state: string | null) => {
  const decodedState = decodeCallbackState(state)
  const stateParams = new URLSearchParams(decodedState)
  const platform = stateParams.get('platform')

  return platform === LoginType.google ? LoginType.google : LoginType.o365
}

const getInitialLoginType = () => {
  if (typeof window === 'undefined') return LoginType.o365

  const params = new URLSearchParams(window.location.search)
  return getLoginTypeFromState(params.get('state'))
}

const cleanLoginCallbackURL = () => {
  const params = new URLSearchParams(window.location.search)
  params.delete('code')
  params.delete('state')
  params.delete('session_state')
  const search = params.toString()
  window.history.replaceState(
    null,
    '',
    window.location.pathname + (search ? `?${search}` : '')
  )
}

const login = async (email: string, loginUrl: string, isRemember: boolean) => {
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.showBreak)
  clearStoredAccessToken()
  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.pendingLoginEmail, btoa(email))
  if (isRemember)
    localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.rememberedEmail, email)
  window.location.href = loginUrl.includes('prompt=')
    ? loginUrl
    : `${loginUrl}${loginUrl.includes('?') ? '&' : '?'}prompt=login`
}

export {
  decodeCallbackState,
  getLoginTypeFromState,
  getInitialLoginType,
  cleanLoginCallbackURL,
  login,
}
